export const GROUP_TYPES = {
  ASSOCIATION: "association",
  CONTACTS: "contacts",
  FIRM: "firm",
  HOUSTON: "houston",
  INDUSTRY: "industry",
  INTERNAL: "internal",
  LISTSERV: "listserv",
  MEETINGS: "meetings",
  OPEN: "open",
  PRACTICE: "practice",
  TEAM: "team",
  WSGOPEN: "wsgopen",
} as const;

export type GroupType = typeof GROUP_TYPES[keyof typeof GROUP_TYPES];
